import { render, staticRenderFns } from "./Tarifas.vue?vue&type=template&id=7a7a08a3&scoped=true&"
import script from "./Tarifas.vue?vue&type=script&lang=ts&"
export * from "./Tarifas.vue?vue&type=script&lang=ts&"
import style0 from "./Tarifas.vue?vue&type=style&index=0&id=7a7a08a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7a08a3",
  null
  
)

export default component.exports